var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 500,
    height: 500,
    className: "illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0457d;}.cls-2{fill:#fff;}.cls-3{fill:#0099f5;}.cls-4{fill:#ffd44d;}.cls-5{fill:#ff9515;}.cls-6{fill:#0064f4;}.cls-7{fill:none;stroke:#231f20;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.75,75l-3.91-3a14.36,14.36,0,0,0,0-3.21l3.91-3.06a1.91,1.91,0,0,0,.46-2.44l-4.06-7a1.92,1.92,0,0,0-2.35-.85l-4.61,1.85a16.21,16.21,0,0,0-2.77-1.6l-.7-4.9a1.89,1.89,0,0,0-1.89-1.63H46.68a1.89,1.89,0,0,0-1.87,1.62l-.71,4.91a15.91,15.91,0,0,0-2.76,1.61l-4.62-1.86a1.87,1.87,0,0,0-2.33.83l-4.07,7a1.9,1.9,0,0,0,.46,2.45l3.91,3.06a14.36,14.36,0,0,0,0,3.21L30.78,75a1.9,1.9,0,0,0-.47,2.44l4.07,7a1.93,1.93,0,0,0,2.35.85l4.6-1.85a16.61,16.61,0,0,0,2.77,1.6L44.81,90a1.89,1.89,0,0,0,1.87,1.64h8.15A1.89,1.89,0,0,0,56.71,90l.71-4.91a15.54,15.54,0,0,0,2.76-1.61l4.63,1.86a1.88,1.88,0,0,0,2.33-.83l4.08-7.07A1.91,1.91,0,0,0,70.75,75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.13,60.37a9.24,9.24,0,0,0-1.91-.19,10,10,0,1,0,1.91.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.11,31.21a8.52,8.52,0,0,1,7,8.36h0a3.81,3.81,0,0,1-3.81,3.81h-11a3.81,3.81,0,0,1-3.81-3.81h0a8.53,8.53,0,0,1,7.05-8.38"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 32.54,
    y: 16.42,
    width: 12.27,
    height: 14.43,
    rx: 6.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.21,30.34v1.84a2.44,2.44,0,0,1-2.44,2.44h0a2.44,2.44,0,0,1-2.44-2.44V30.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65.14,31.21a8.51,8.51,0,0,1,6.94,8.36h0a3.81,3.81,0,0,1-3.81,3.81H57.32a3.8,3.8,0,0,1-3.81-3.81h0a8.52,8.52,0,0,1,7-8.38"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 56.57,
    y: 16.42,
    width: 12.27,
    height: 14.43,
    rx: 6.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.24,30.34v1.84a2.45,2.45,0,0,1-2.45,2.44h0a2.44,2.44,0,0,1-2.44-2.44V30.39"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M70.75,75l-3.91-3a14.36,14.36,0,0,0,0-3.21l3.91-3.06a1.91,1.91,0,0,0,.46-2.44l-4.06-7a1.92,1.92,0,0,0-2.35-.85l-4.61,1.85a16.21,16.21,0,0,0-2.77-1.6l-.7-4.9a1.89,1.89,0,0,0-1.89-1.63H46.68a1.89,1.89,0,0,0-1.87,1.62l-.71,4.91a15.91,15.91,0,0,0-2.76,1.61l-4.62-1.86a1.87,1.87,0,0,0-2.33.83l-4.07,7a1.9,1.9,0,0,0,.46,2.45l3.91,3.06a14.36,14.36,0,0,0,0,3.21L30.78,75a1.9,1.9,0,0,0-.47,2.44l4.07,7a1.93,1.93,0,0,0,2.35.85l4.6-1.85a16.61,16.61,0,0,0,2.77,1.6L44.81,90a1.89,1.89,0,0,0,1.87,1.64h8.15A1.89,1.89,0,0,0,56.71,90l.71-4.91a15.54,15.54,0,0,0,2.76-1.61l4.63,1.86a1.88,1.88,0,0,0,2.33-.83l4.08-7.07A1.91,1.91,0,0,0,70.75,75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M41.08,31.39A8.5,8.5,0,0,1,48,39.75h0a3.82,3.82,0,0,1-3.81,3.81h-11a3.81,3.81,0,0,1-3.81-3.81h0a8.49,8.49,0,0,1,1.36-4.62,6.43,6.43,0,0,1,2.42-2.46,11,11,0,0,1,3.26-1.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 32.6,
    y: 16.59,
    width: 12.27,
    height: 14.43,
    rx: 6.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M41.27,30.46V32.3a2.45,2.45,0,0,1-2.45,2.44h0a2.44,2.44,0,0,1-2.44-2.44V30.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M65.1,31.39A8.5,8.5,0,0,1,72,39.75h0a3.81,3.81,0,0,1-3.81,3.81h-11a3.82,3.82,0,0,1-3.81-3.81h0a8.49,8.49,0,0,1,1.36-4.62,6.43,6.43,0,0,1,2.42-2.46,11,11,0,0,1,3.26-1.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 56.62,
    y: 16.59,
    width: 12.27,
    height: 14.43,
    rx: 6.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M65.29,30.46V32.3a2.44,2.44,0,0,1-2.44,2.44h0a2.44,2.44,0,0,1-2.44-2.44V30.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M53,60.43a10.05,10.05,0,0,0-1.91-.18,9.93,9.93,0,1,0,0,19.86A10.06,10.06,0,0,0,53,79.92a9.93,9.93,0,0,0,6.6-14.86"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.f80f2ce9e1d350906e9f4240f18fce90.svg";
export { ForwardRef as ReactComponent };